/**
 * Permissions effectives du CRM Lanala — matrice complète synchronisée avec le backend.
 * Ces valeurs correspondent exactement aux claims `permissions` de la réponse de login (AuthCentral).
 * Ne pas modifier sans synchronisation avec le backend.
 */
export const PERMISSIONS = {
  // ─── Tickets ────────────────────────────────────────────────────────────────
  TICKET_CREATE: 'TICKET_CREATE',
  TICKET_READ: 'TICKET_READ',
  TICKET_UPDATE: 'TICKET_UPDATE',
  TICKET_RESOUDRE: 'TICKET_RESOUDRE',
  TICKET_TRANSFERER: 'TICKET_TRANSFERER',
  TICKET_ASSIGNER_BO: 'TICKET_ASSIGNER_BO',
  TICKET_CHANGER_STATUT: 'TICKET_CHANGER_STATUT',
  TICKET_CLOTURER: 'TICKET_CLOTURER',
  TICKET_HISTORIQUE_READ: 'TICKET_HISTORIQUE_READ',
  TICKET_VALIDATE: 'TICKET_VALIDATE',
  TICKET_READ_ALL: 'TICKET_READ_ALL',
  TICKET_READ_TEAM: 'TICKET_READ_TEAM',
  TICKET_MODIFIER_NOTE: 'TICKET_MODIFIER_NOTE',
  TICKET_REQUEST_INFO: 'TICKET_REQUEST_INFO',
  TICKET_ESCALATE: 'TICKET_ESCALATE',
  TICKET_ATTACHMENT: 'TICKET_ATTACHMENT',
  TICKET_TREAT: 'TICKET_TREAT',
  TICKET_TREAT_LEVEL2: 'TICKET_TREAT_LEVEL2',
  TICKET_PRENDRE_EN_CHARGE: 'TICKET_PRENDRE_EN_CHARGE',
  TICKET_COMMENT: 'TICKET_COMMENT',
  TICKET_ASSIGN: 'TICKET_ASSIGN',
  TICKET_RETURN_TO_SUPERVISOR: 'TICKET_RETURN_TO_SUPERVISOR',
  TICKET_REOPEN: 'TICKET_REOPEN',
  TICKET_NOTER_SATISFACTION: 'TICKET_NOTER_SATISFACTION',
  TICKET_EXPORTER: 'TICKET_EXPORTER',

  // ─── Traitement partagé ──────────────────────────────────────────────────────
  TRAITEMENT_PARTAGE_READ: 'TRAITEMENT_PARTAGE_READ',
  TRAITEMENT_PARTAGE_PRENDRE_EN_CHARGE: 'TRAITEMENT_PARTAGE_PRENDRE_EN_CHARGE',

  // ─── Clients ────────────────────────────────────────────────────────────────
  CLIENT_CREATE: 'CLIENT_CREATE',
  CLIENT_READ: 'CLIENT_READ',
  CLIENT_UPDATE: 'CLIENT_UPDATE',
  CLIENT_READ_HISTORY: 'CLIENT_READ_HISTORY',
  CLIENT_EXPORTER: 'CLIENT_EXPORTER',

  // ─── Retours clients ────────────────────────────────────────────────────────
  RETOUR_CLIENT_CREATE: 'RETOUR_CLIENT_CREATE',
  RETOUR_CLIENT_READ: 'RETOUR_CLIENT_READ',
  RETOUR_CLIENT_UPDATE: 'RETOUR_CLIENT_UPDATE',
  RETOUR_CLIENT_CONVERTIR: 'RETOUR_CLIENT_CONVERTIR',
  RETOUR_CLIENT_EXPORTER: 'RETOUR_CLIENT_EXPORTER',

  // ─── Insatisfactions terrain ────────────────────────────────────────────────
  INSATISFACTION_CREATE: 'INSATISFACTION_CREATE',
  INSATISFACTION_READ: 'INSATISFACTION_READ',
  INSATISFACTION_UPDATE: 'INSATISFACTION_UPDATE',
  INSATISFACTION_RAPPORT_READ: 'INSATISFACTION_RAPPORT_READ',
  INSATISFACTION_EXPORTER: 'INSATISFACTION_EXPORTER',

  // ─── Satisfaction client ────────────────────────────────────────────────────
  SATISFACTION_APPEL_READ: 'SATISFACTION_APPEL_READ',
  SATISFACTION_TRAITEMENT_READ: 'SATISFACTION_TRAITEMENT_READ',
  SATISFACTION_PRODUIT_CREATE: 'SATISFACTION_PRODUIT_CREATE',
  SATISFACTION_PRODUIT_READ: 'SATISFACTION_PRODUIT_READ',
  SATISFACTION_RAPPORT_READ: 'SATISFACTION_RAPPORT_READ',
  SATISFACTION_EXPORTER: 'SATISFACTION_EXPORTER',

  // ─── Téléphonie ──────────────────────────────────────────────────────────
  TELEPHONIE_APPEL_READ: 'TELEPHONIE_APPEL_READ',

  // ─── Call Center ─────────────────────────────────────────────────────────
  CALL_CREATE: 'CALL_CREATE',
  CALL_READ: 'CALL_READ',
  CALL_UPDATE: 'CALL_UPDATE',
  CALL_DELETE: 'CALL_DELETE',
  CALL_EXPORTER: 'CALL_EXPORTER',

  // ─── Vente croisée & Saturation ──────────────────────────────────────────
  VENTE_CROISEE_READ: 'VENTE_CROISEE_READ',
  VENTE_CROISEE_EXPORTER: 'VENTE_CROISEE_EXPORTER',

  // ─── Messagerie & Notifications ──────────────────────────────────────────
  MESSAGERIE_READ: 'MESSAGERIE_READ',
  MESSAGERIE_ECRIRE: 'MESSAGERIE_ECRIRE',
  MESSAGERIE_EXPORTER: 'MESSAGERIE_EXPORTER',

  // ─── Prospection / Leads ───────────────────────────────────────────────────
  LEAD_CREATE: 'LEAD_CREATE',
  LEAD_READ: 'LEAD_READ',
  LEAD_DELETE: 'LEAD_DELETE',
  LEAD_EXPORTER: 'LEAD_EXPORTER',

  // ─── Référentiels & Administration ───────────────────────────────────────────
  REFERENTIEL_READ: 'REFERENTIEL_READ',
  REFERENTIEL_GERER: 'REFERENTIEL_GERER',
  REFERENTIEL_ENTITY_ASSIGN: 'REFERENTIEL_ENTITY_ASSIGN',
  CREER_UN_UTILISATEUR: 'CREER_UN_UTILISATEUR',

  // ─── Reporting ───────────────────────────────────────────────────────────────
  REPORTING_READ: 'REPORTING_READ',
  REPORTING_EXPORTER: 'REPORTING_EXPORTER',
  REPORTING_QUALITY_MONITORING: 'REPORTING_QUALITY_MONITORING',

  // ─── Direction ──────────────────────────────────────────────────────────────
  DIRECTEUR_VUE_GLOBALE_READ: 'DIRECTEUR_VUE_GLOBALE_READ',

  // ─── Intégration externe (back-office externe) ───────────────────────────────
  INTEGRATION_EXTERNE_READ: 'INTEGRATION_EXTERNE_READ',
  INTEGRATION_EXTERNE_GERER: 'INTEGRATION_EXTERNE_GERER',

  // ─── Système / Admin technique ───────────────────────────────────────────────
  SYSTEME_PROVISIONNER_AUTHCENTRAL: 'SYSTEME_PROVISIONNER_AUTHCENTRAL',
  SYSTEME_JOURNAL_READ: 'SYSTEME_JOURNAL_READ',
  UTILISATEUR_BRANCH_READ: 'UTILISATEUR_BRANCH_READ',
  UTILISATEUR_BRANCH_GERER: 'UTILISATEUR_BRANCH_GERER',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
export type PermissionKey = keyof typeof PERMISSIONS;

/**
 * Regroupements logiques de permissions par capacité métier.
 * Utilisez ces groupes plutôt que des combinaisons répétées à travers l'appli.
 */
export const PERMISSION_GROUPS = {
  /** Peut traiter les tickets : prendre en charge, traiter ou traiter au niveau 2. */
  TRAITER_TICKET: [
    PERMISSIONS.TICKET_TREAT,
    PERMISSIONS.TICKET_TREAT_LEVEL2,
    PERMISSIONS.TICKET_PRENDRE_EN_CHARGE,
  ],
  /** Peut consulter les dossiers (les siens, ceux de son équipe ou de toutes les entités). */
  CONSULTER_TICKET: [
    PERMISSIONS.TICKET_READ,
    PERMISSIONS.TICKET_READ_TEAM,
    PERMISSIONS.TICKET_READ_ALL,
    PERMISSIONS.TICKET_HISTORIQUE_READ,
  ],
  /** Peut transférer/affecter un dossier (superviseur, back office, escalade). */
  TRANSFERER_TICKET: [
    PERMISSIONS.TICKET_TRANSFERER,
    PERMISSIONS.TICKET_ASSIGNER_BO,
    PERMISSIONS.TICKET_ASSIGN,
    PERMISSIONS.TICKET_RETURN_TO_SUPERVISOR,
  ],
  /** Peut administrer les utilisateurs (création, affectation d'entité, gestion des référentiels). */
  ADMIN_UTILISATEURS: [
    PERMISSIONS.CREER_UN_UTILISATEUR,
    PERMISSIONS.REFERENTIEL_GERER,
    PERMISSIONS.REFERENTIEL_ENTITY_ASSIGN,
  ],
  /** Peut accéder au reporting et aux indicateurs. */
  CONSULTER_REPORTING: [
    PERMISSIONS.REPORTING_READ,
    PERMISSIONS.REPORTING_EXPORTER,
    PERMISSIONS.REPORTING_QUALITY_MONITORING,
  ],
  /** Peut échanger sur les tickets (commenter, joindre un fichier, demander des infos). */
  COMMUNIQUER_TICKET: [
    PERMISSIONS.TICKET_COMMENT,
    PERMISSIONS.TICKET_ATTACHMENT,
    PERMISSIONS.TICKET_REQUEST_INFO,
  ],
} as const;

export type PermissionGroupKey = keyof typeof PERMISSION_GROUPS;
